import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = 'nominas/nominas';

/**
 * GET Periodos en los que el colaborador tiene nóminas autorizadas
 * @param {object} params { sujeto, colaborador }
 * @returns {Promise<object[]>}
 */
export const getPeriodosPorColaborador = async (params) => {
  try {
    const response = await API.get(`${baseURI}/periodos-por-colaborador`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Reporte de Nóminas por Colaborador
 * @param {object} params { sujeto, colaborador, periodo_inicial, periodo_final }
 * @returns {Promise<object|null>}
 */
export const getReporteNominasPorColaborador = async (params) => {
  try {
    const response = await API.get(`${baseURI}/reporte-por-colaborador`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
